import { Injectable } from '@angular/core';
import { ContactsService } from '../api'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContactResolverService implements Resolve<any> {

    constructor(
        private dataService: ContactsService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return this.dataService.contactDetailsQuery(route.paramMap.get('id'));
    }
}
